import {
  Button,
  ButtonGroup,
  Center,
  HStack,
  Heading,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getHeadersForRequest, numberWithCommas } from "../utils/functions";
import axios from "axios";
import { Loading } from "../components/Loading";
import { PaymentCard } from "../components/PaymentCard";
import Nav from "../components/navbar";
import { PaymentsList, PresetPrices } from "../utils/types";
import { FaEye, FaPencilAlt, FaTrash } from "react-icons/fa";
import useCustomTranslation from "../hooks/useCustomTranslation";
import { AddPresetPrice } from "../components/AddPresetPrice";
import { AddIcon } from "@chakra-ui/icons";

const CustomerPresetPricesScreen = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [selectedPreset, setSelectedPreset] = useState<PresetPrices>();
  const [modalIsLoading, setModalIsLoading] = useState<boolean>(false);
  const [presetPrices, setPresetPrices] = useState<PresetPrices[]>([]);
  const { t, changeLanguage } = useCustomTranslation();
  const { isOpen, onToggle } = useDisclosure();
  const toast = useToast();
  const { customerId, customerName } = useParams<{
    customerId: string;
    customerName: string;
  }>();

  useEffect(() => {
    setIsLoading(true);
    loadData();
  }, []);

  const handlePresetSaved = () => {
    setShowAddModal(false);   // close modal
    setIsEdit(false);
    setSelectedPreset(undefined);
    loadData();               // refresh list (you already call loadData on modal toggle, so this is optional)
    // toast({
    //   title: t("Saved"),
    //   status: "success",
    //   duration: 2500,
    //   isClosable: true,
    //   position: "bottom-right",
    // });
  };

  const loadData = async () => {
    try {
      const headers = await getHeadersForRequest();
      console.log(customerId);
      const response = await axios.post(
        `${process.env.REACT_APP_TEST_API_URL}/customers/getPresetPrices`,
        { id: customerId },
        { headers }
      );
      console.log(response);
      setPresetPrices(response.data.responseData);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleDataClick = (data: PresetPrices) => {
    console.log(data);
    setIsEdit(true);
    setShowAddModal(true);
    setSelectedPreset(data);
  };

  // const voidTransaction = async () => {
  //   setModalIsLoading(true);
  //   try {
  //     const headers = await getHeadersForRequest();
  //     await axios
  //       .post(
  //         `${process.env.REACT_APP_TEST_API_URL}/payments/delete`,
  //         {
  //           transactionId: selectedTransaction,
  //         },
  //         { headers }
  //       )
  //       .then((response) => {
  //         console.log(response.data);
  //         toast({
  //           title: t("Transaction VOID successful"),
  //           duration: 3000,
  //           status: "success",
  //         });
  //         setShowConfirmationModal(false);
  //         getAllTransactions();
  //         setModalIsLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //         setModalIsLoading(false);
  //         setShowConfirmationModal(false);
  //         toast({
  //           title: t("Error, please try again later"),
  //           duration: 3000,
  //           status: "error",
  //         });
  //       });
  //   } catch (error) {
  //     toast({ title: "Error", status: "error" });
  //     console.error(error);
  //   }
  // };

  return (
    <Stack>
      <Stack position="sticky" top={0} zIndex={1} width="full">
        <Nav pageName={"Preset Prices"}/>
      </Stack>
      <Stack flex={1}>
        <Stack pt={2} pb={10} px={3}>
          {isLoading ? (
            <Center h={600}>
              <Loading />
            </Center>
          ) : (
            <>
              <Text>{customerName}</Text>
              <Text>
                {t("Total items:")}
                {presetPrices.length}
              </Text>
              {presetPrices.length > 0 && (
                <Stack pt={10}>
                  <TableContainer>
                    <Table variant="simple">
                      <TableCaption>
                        {" "}
                        {t("NumberOfItems")} {presetPrices.length}
                      </TableCaption>
                      <Thead>
                        <Tr>
                          <Th>Item</Th>
                          <Th>Packet Size</Th>
                          <Th>Status</Th>
                          <Th isNumeric>Price</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {presetPrices.map((items, key) => (
                          <Tr
                            key={key}
                            onClick={() => {
                              setSelectedPreset(items);
                              setShowAddModal(true);
                              setIsEdit(true);
                            }}
                          >
                            <Td>{items.product}</Td>
                            <Td>
                                {items.size} - {parseInt(items.size) > 999 ? "Kgs" : "gms"}
                            </Td>
                            <Td color={items.isVoid ? "red" : "unset"}>{items.isVoid ? "Disabled" : "Enabled"}</Td>
                            <Td isNumeric>
                              {numberWithCommas(items.price)}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </Stack>
              )}
              {presetPrices.length < 1 && (
                <Stack alignItems={"center"} justifyContent={"center"} h={400}>
                  <Text fontSize={20} textAlign={"center"}>
                    {t("There are no preset prices")}
                  </Text>
                  <Text fontSize={20} textAlign={"center"}>
                    {t(
                      "Add one now!"
                    )}
                  </Text>
                </Stack>
              )}
            </>
          )}

          {/* CONFIRMATION MODAL */}
          <Modal
            isCentered
            closeOnOverlayClick={false}
            isOpen={showConfirmationModal}
            onClose={() => setShowConfirmationModal(false)}
          >
            <ModalContent maxWidth="350">
              <ModalCloseButton />
              <ModalHeader>{t("Alert")}</ModalHeader>
              <ModalBody>
                <Stack>
                  <Text textAlign={"center"}>
                    {t("Are you sure you want to VOID this receipt?")}
                  </Text>
                  <Text textAlign={"center"}>
                    {t("THIS ACTION IS IRREVERSIBLE!")}
                  </Text>
                </Stack>
              </ModalBody>
              <ModalFooter>
                <ButtonGroup>
                  <Button
                    variant="ghost"
                    colorScheme="blueGray"
                    onClick={() => {
                      setShowConfirmationModal(false);
                    }}
                  >
                    {t("No")}
                  </Button>
                  <Button
                    bg={"red"}
                    isLoading={modalIsLoading}
                    onClick={() => {
                      // voidTransaction();
                    }}
                  >
                    {t("Yes")}
                  </Button>
                </ButtonGroup>
              </ModalFooter>
            </ModalContent>
          </Modal>


          {/* ADD MODAL */}
          <Modal
            isCentered
            closeOnOverlayClick={false}
            isOpen={showAddModal}
            onClose={() => setShowAddModal(false)}
          >
            <ModalContent maxWidth="350">
              <ModalCloseButton />
              <ModalHeader>{isEdit ? "Add " : "Edit "} Preset Price</ModalHeader>
              <ModalBody>
                {!isEdit && <AddPresetPrice customerId={customerId ? parseInt(customerId) : 0} onSuccess={handlePresetSaved}/>}
                {isEdit && selectedPreset !== undefined && <AddPresetPrice customerId={customerId ? parseInt(customerId) : 0} isEdit={true} id={selectedPreset.id} isVoid={selectedPreset.isVoid} price={selectedPreset.price.toString()} product={selectedPreset.product} size={selectedPreset.size} onSuccess={handlePresetSaved}/>}
              </ModalBody>
            </ModalContent>
          </Modal>
        </Stack>

        <Tooltip hasArrow label="Add New Session">
          <IconButton
            position={"fixed"}
            right={5}
            bottom={5}
            onClick={() => setShowAddModal(true)}
            // onClick={()=> onToggle}
            isRound={true}
            variant="solid"
            colorScheme="blue"
            aria-label="Done"
            fontSize="20px"
            icon={<AddIcon />}
            onMouseEnter={onToggle}
            onMouseLeave={onToggle}
          />
        </Tooltip>
        
      </Stack>
    </Stack>
  );
};

export default CustomerPresetPricesScreen;
